export default __webpack_public_path__ + "static/media/gain-internal-support.3e38ccef.svg";